<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <input type="checkbox" class="checkbox" v-model="value" v-bind="$attrs" />
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  modelValue?: boolean;
}>();

const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  }
});
</script>

<style scoped lang="scss">
input[type="checkbox"] {
  -webkit-appearance: none;
  appearance: none;
  background-color: $color-background-form-field-default;
  border: 1px solid $color-border-input;
  border-radius: 2px;
  display: grid;
  flex-shrink: 0;
  height: 1.125rem;
  margin: 0;
  place-content: center;
  position: relative;
  width: 1.125rem;
}

input[type="checkbox"]::before {
  display: flex;
  justify-content: center;
}

.checkbox::before {
  border-bottom: 2px solid $color-text-input-default;
  border-right: 2px solid $color-text-input-default;
  content: "";
  display: inline-block;
  height: 0.75rem;
  left: 0.3rem;
  opacity: 0;
  position: absolute;
  top: 0.025rem;
  transform: rotate(45deg);
  width: 0.4rem;
}

input[type="checkbox"]:checked::before {
  opacity: 1;
}

input[type="checkbox"]:hover,
input[type="checkbox"]:focus {
  border-color: $color-border-input-hovered;
  cursor: pointer;
}

input[type="checkbox"]:disabled {
  background-color: $color-background-form-field-disabled;
  border-color: $color-border-subtle;
  cursor: default;
}

input[type="checkbox"]:disabled::before {
  border-color: $color-text-input-disabled;
}
</style>
